import { SuccessorAccountEntry } from "hooks/successors/GetMySuccessorAccountsHook";
import { useGetInvestmentsSummary } from "hooks/investments";
import "./SuccessorOwnerSelector.scss";

interface Props {
  owners: SuccessorAccountEntry[];
  selectedOwnerUuid: string | null;
  onSelect: (uuid: string | null) => void;
  hasBannerBelow?: boolean;
}

function pluralAssets(count: number): string {
  if (count === 1) return "1 aktywo";
  if (count >= 2 && count <= 4) return `${count} aktywa`;
  return `${count} aktywów`;
}

const SuccessorOwnerSelector = ({
  owners,
  selectedOwnerUuid,
  onSelect,
  hasBannerBelow = false,
}: Props) => {
  const { data: summary } = useGetInvestmentsSummary();
  const myAssetsCount = summary?.combined?.totalTypesCount ?? 0;

  return (
    <div className={`successor-owner-selector${hasBannerBelow ? " successor-owner-selector--with-banner" : ""}`}>
      <p className="successor-owner-selector__label">
        Wybierz czyje aktywa chcesz przeglądać.
      </p>
      <div className={`successor-owner-selector__tiles${owners.length === 1 ? " successor-owner-selector__tiles--two" : ""}`}>
        <button
          className={`successor-owner-selector__tile${
            selectedOwnerUuid === null
              ? " successor-owner-selector__tile--active"
              : ""
          }`}
          onClick={() => onSelect(null)}
        >
          <span className="successor-owner-selector__tile-name">
            Moje Aktywa
          </span>
          <span className="successor-owner-selector__tile-sub">
            {pluralAssets(myAssetsCount)}
          </span>
        </button>

        {owners.map((owner) => (
          <button
            key={owner.ownerUuid}
            className={`successor-owner-selector__tile${
              selectedOwnerUuid === owner.ownerUuid
                ? " successor-owner-selector__tile--active"
                : ""
            }`}
            onClick={() => onSelect(owner.ownerUuid)}
          >
            <span className="successor-owner-selector__tile-name">
              {owner.ownerName}
            </span>
            <span className="successor-owner-selector__tile-sub">
              {pluralAssets(owner.investmentsCount)}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuccessorOwnerSelector;
